import React from "react";
import {NavLink} from "react-router-dom";
import {Nav} from "reactstrap";
import {motion} from "framer-motion";
import PerfectScrollbar from "perfect-scrollbar";

import logo from "logo_ncentiva.svg";

let ps = null;

function Sidebar(props)
{
	const sidebar = React.useRef();
	const activeRoute = (routeName) =>
	{
		return props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
	};

	// Setting up Perfect Scroll plugin
	React.useEffect(() =>
	{
		if (navigator.platform.indexOf("Win") > -1 && ps === null)
		{
			ps = new PerfectScrollbar(sidebar.current, {
				suppressScrollX: true, suppressScrollY: false,
			});
		}
		return function cleanup()
		{
			if (navigator.platform.indexOf("Win") > -1)
			{
				ps.destroy();
			}
		};
	});

	return (<div className="sidebar" data-color="black" data-active-color="danger">
		<div className="logo" style={{backgroundColor:'white'}}>
			<div className="logo-img">
				<motion.img initial={{opacity: 0, scale: 0.1}} animate={{
					opacity: 1, scale: 1
				}} transition={{duration: 0.8}} src="https://ncentiva-development.s3.eu-west-1.amazonaws.com/ncentiva_new_lowquality_logo.png" alt="Ncentiva"/>
			</div>
		</div>
		<div className="sidebar-wrapper" ref={sidebar} style={{backgroundColor:"white"}}>
			<Nav>
				{props.routes.map((prop, key) =>
				
				{
					if (!prop.noShow && prop.layout !== "/purchaser")
					{
						return (<li className={activeRoute(prop.path)} key={key}>
							<NavLink to={prop.layout + prop.path} className="nav-link" activeClassName="active" isActive={(match, location) =>
							{
								if (!match)
									return false;
								props.startLoader(location.pathname);
								return true;
							}}  
							onClick={(e) => {
								if (props.location.pathname === prop.layout + prop.path) {
								e.preventDefault(); 
								}
							}}
							style={{color:"black"}}
							>
								
								<i className={prop.icon} style={{color:"black"}}/>
								<p>{prop.name}</p>
							</NavLink>
						</li>);
					}
					return null;
				})}
			</Nav>
		</div>
	</div>);
}

export default Sidebar;
